import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.css';

import '@/css/desktop/tooltip.scss';

import '@/js/desktop/components/search/useFilters/styles/useFilters.css';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';

import firstPaymentDefinitionService from '@/js/common/Domain/Service/firstPaymentDefinition';

import Vue, { ref } from 'vue';
import PartialPaymentPopup from '@ve/components/partialPayment/partialPaymentPopup/desktop/PartialPaymentPopup.vue';
import PartialPaymentBannerForProductCard from '@ve/components/partialPayment/partialPaymentBannerForProductCard/desktop/PartialPaymentBannerForProductCard.vue';
import CashbackPartialPaymentBannerForProductCard from '@ve/components/partialPayment/cashbackPartialPaymentBannerForProductCard/desktop/CashbackPartialPaymentBannerForProductCard.vue';
import checkProductCashbackAvailable from '@/js/common/Domain/Service/checkProductCashbackAvailable';
import SearchPageHotelCardAbstract from '@/js/desktop/View/Abstract/SearchPageHotelCardAbstract';

import '@/css/common/components/warranted-icon.scss';
import SerpTrackingService from '@ve/pages/serp/analytics/yandexAnalytics/serpTrackingService';
import { productTypes } from '@fr/constants';
import preparePropsForHotelCardRightBlock from '@ve/components/serpHotelCard/services/preparePropsForHotelCardRightBlock';

import template from './searchPageHotelOffers/hotelTemplate.html';
import initGiftCertificatesBanner from '@ve/components/banners/giftCertificates/initGiftCertificatesBanner';
import hotelGiftCertificatesBannerTemplate from '@view/desktop/travelata/layout/parts/search/search__hotel-gift-certificates-js.phtml';
const CASHBACK_BANNER_HTML = `
    <div class="serpHotelCard serpHotelCard--cashback-banner">
        <div class="b-tour-components b-tour-components_cashback-banner">
            <div
                class="js-gift-certificates-banner js-cashback-banner"
                data-custom-class="search-class"
                data-custom-class-container="search-class-container"
                data-is-search-page="true"
                data-show-cashback-banner="true"
            ></div>
        </div>
    </div>
`;

const SearchPageHotelOfferViewModel = Backbone.Epoxy.Model.extend({
  defaults: {
    hotelIndex: null,
    totalHotels: null,
  },
  computeds: {
    hotelGiftCertificatesBanner: {
      deps: ['hotelIndex', 'totalHotels'],
      get(hotelIndex, totalHotels) {
        const shouldShow = hotelIndex === 3 || (hotelIndex === 19 && totalHotels >= 30);
        return shouldShow ? hotelGiftCertificatesBannerTemplate({ hotelIndex }) : '';
      },
    },
  },
});

@extendDecorator({
  el: '<div class="serpHotelCard"></div>',
  data: null,
  template,
  bindings: {
    '.js-hotelGiftCertificatesBanner': 'html: hotelGiftCertificatesBanner',
  },
  events: {
    'click .goToHotel': 'goToHotel',
    'click .js-images-carousel-control-prev': 'sliderArrowClick',
    'click .js-images-carousel-control-next': 'sliderArrowClick',
    'mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange)': 'hotelClick',
    'click .serpHotelCard__container a:not(.goto-ua-page, .notChange)': 'callYMGoals',
  },
})
export default class SearchPageHotelOfferView extends SearchPageHotelCardAbstract {
  trackingHotelClick() {
    trackingService.trackSerpHotelPosition({
      hotels: this.collectionView.collection,
      selectedHotel: this.model,
      sortStrategy: this.collectionView.model.get('sortStrategy'),
    });

    mindBoxService.trackViewSerpClick('serp_hotel', {
      searhPageModel: this.model,
      collectionViewModel: this.collectionView.model,
    });
  }

  hotelClick(e) {
    this.trackingHotelClick();
    this.hrefUrl(e);
  }

  render() {
    let tmpl;
    const data = this.model.toJSON({ computed: true });
    const hotelIndex = this.collectionView.collection.indexOf(this.model);
    const totalHotels = this.collectionView.collection.length;

    if (this.collectionView) {
      tmpl = this.selectTemplate();
    }

    data.originalHotelObject = this.model;

    data.hotelIndex = hotelIndex;

    if (this.viewModel) {
      this.viewModel.set({
        hotelIndex,
        totalHotels,
      });
    } else {
      this.viewModel = new SearchPageHotelOfferViewModel({
        hotelIndex,
        totalHotels,
      });
    }

    if (this.hotelMapView) {
      this.hotelMapView.reRender({
        data,
        $el: this.$el,
        parentModel: this.model,
        collectionView: this.collectionView,
      });
    } else {
      this.$el.html(tmpl(data));
    }

    setTimeout(() => {
      this.applyBindings();
      this.addBannerAfterCardIfNeeded();
      this.addCashbackBannerIfNeeded();
      initGiftCertificatesBanner();
    }, 0);

    this.data = data;

    this.initCarousel();
    this.renderPhotos();
    this.initSubViews();
    this.initVueComponents();

    this.showBottomBanner();
  }

  addBannerAfterCardIfNeeded() {
    const bannerHtml = this.viewModel.get('hotelGiftCertificatesBanner');

    if (!this.$el.parent().length) {
      return;
    }

    const nextSibling = this.$el[0].nextElementSibling;
    const existingBanner = nextSibling && nextSibling.classList.contains('b-tour-components');

    if (bannerHtml) {
      if (!existingBanner) {
        this.$el.after(bannerHtml);
      }
    } else if (existingBanner) {
      $(nextSibling).remove();
    }
  }

  shouldShowCashbackBanner(hotelIndex) {
    return hotelIndex === 0 && window?.appConfig?.vamPrivet;
  }

  getCashbackBannerElement() {
    const tpl = document.createElement('template');
    tpl.innerHTML = CASHBACK_BANNER_HTML.trim();
    return tpl.content.firstElementChild.cloneNode(true);
  }

  removeCashbackBannerAfterCard() {
    const hotelIndex = this.collectionView.collection.indexOf(this.model);
    if (hotelIndex !== 0) {
      return;
    }
    const nextEl = this.$el[0]?.nextElementSibling;
    if (nextEl && nextEl.classList.contains('serpHotelCard--cashback-banner')) {
      nextEl.remove();
    }
  }

  insertCashbackBannerAfterCard() {
    const scheduleInsertion = (attempt = 0) => {
      if (!this.$el.parent().length) {
        if (attempt < 50) {
          requestAnimationFrame(() => scheduleInsertion(attempt + 1));
        }
        return;
      }

      const parentNode = this.$el[0]?.parentNode;
      const bannerElement = this.getCashbackBannerElement();

      if (!parentNode || !bannerElement) {
        return;
      }

      const nextEl = this.$el[0].nextElementSibling;
      if (nextEl && nextEl.classList.contains('serpHotelCard--cashback-banner')) {
        return;
      }

      parentNode.insertBefore(bannerElement, nextEl);

      setTimeout(() => {
        initGiftCertificatesBanner();
      }, 10);
    };

    requestAnimationFrame(scheduleInsertion);
  }

  addCashbackBannerIfNeeded() {
    const hotelIndex = this.collectionView.collection.indexOf(this.model);
    const shouldShowBanner = this.shouldShowCashbackBanner(hotelIndex);

    if (!shouldShowBanner) {
      this.removeCashbackBannerAfterCard();
      return;
    }

    this.insertCashbackBannerAfterCard();
  }

  getPropsForHotelCardRightBlock() {
    const hotelOffer = this.model.get('hotelOffers').at(0);

    return preparePropsForHotelCardRightBlock({
      product: hotelOffer,
      productPrice: hotelOffer.get('price'),
      productType: productTypes.HOTEL_OFFER,
    });
  }

  showBottomBanner() {
    const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();

    const hasTourCashbackAvailable = checkProductCashbackAvailable(this.model.get('hotelOffers'));

    const isCashbackAvailable = window?.appConfig?.cashbackAvailable && hasTourCashbackAvailable;

    if (isCashbackAvailable) {
      if (isVisiblePartialPayment) {
        this.initCashbackPartialPaymentBanner();
        return;
      }
      this.initCashbackBanner('hotelOffer');
      return;
    }

    if (isVisiblePartialPayment) {
      this.initPartialPaymentBanner();
    }
  }

  getPartialPaymentData() {
    const hotelOffers = this.model.get('hotelOffers');
    const hotelOffer = hotelOffers?.at(0);
    const firstPaymentDefinitions = firstPaymentDefinitionService.getData();

    const isVisible = !!hotelOffer.get('firstPaymentDefinition')?.id && firstPaymentDefinitions.length > 0;
    const countryName = this.model.get('country').get('name');

    return {
      isVisible,
      countryName,
      hotelOffers,
    };
  }

  initPartialPaymentPopup(props) {
    const popup = document.createElement('div');
    popup.className = 'partial-payment-popup';
    document.getElementsByTagName('body')[0].appendChild(popup);
    this.partialPaymentPopup = new Vue({
      name: 'partial-payment-popup',
      render: (h) =>
        h(PartialPaymentPopup, {
          props: {
            ...props,
            isPopupVisible: this.isPopupVisible,
          },
        }),
    }).$mount('.partial-payment-popup');
  }

  openPartialPaymentPopup(props) {
    if (!this.partialPaymentPopup) {
      this.initPartialPaymentPopup(props);
    }

    this.isPopupVisible.value = true;
  }

  initPartialPaymentBanner() {
    const { countryName, hotelOffers } = this.getPartialPaymentData();
    this.$el.addClass('partialPayment');
    const el = this.$el.find('.partialPayment__banner').get(0);

    new Vue({
      name: 'partial-payment-banner',
      render: (h) =>
        h(PartialPaymentBannerForProductCard, {
          props: {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
          },
          on: {
            'open-popup': (event) => {
              this.openPartialPaymentPopup(event);
            },
          },
        }),
    }).$mount(el);
  }

  initCashbackPartialPaymentBanner() {
    const { countryName, hotelOffers } = this.getPartialPaymentData();
    this.$el.addClass('cashbackPartialPayment');

    this.cashbackPartialPaymentBanner = new Vue({
      render: (h) =>
        h(CashbackPartialPaymentBannerForProductCard, {
          props: {
            countryName,
            products: hotelOffers.toJSON(),
            productType: 'hotelOffer',
          },
          on: {
            'open-popup': (event) => {
              this.openPartialPaymentPopup({ ...event, 'hotel-page-product': true });
            },
          },
        }),
    }).$mount(this.$el.find('.cashbackPartialPayment__banner').get(0));
  }

  initSubViews() {
    this.warrantyTooltip = new TooltipPopoverHtml({
      el: $('.js-warranted-icon', this.$el),
    });
  }

  initSubscribes() {
    this.listenTo(this.model, 'change:minPrice', $.proxy(this.reRender, this));
    this.listenTo(this.model, 'change:hotelOffers', $.proxy(this.reRender, this));
    if (this.collectionView && this.collectionView.collection) {
      this.listenTo(this.collectionView.collection, 'add remove reset update', () => {
        this.updateBannerAfterCollectionChange();
      });
    }
  }

  updateBannerAfterCollectionChange() {
    if (this.viewModel && this.collectionView) {
      const hotelIndex = this.collectionView.collection.indexOf(this.model);
      const totalHotels = this.collectionView.collection.length;

      this.viewModel.set({
        hotelIndex,
        totalHotels,
      });
      setTimeout(() => {
        this.addBannerAfterCardIfNeeded();
        this.addCashbackBannerIfNeeded();
        initGiftCertificatesBanner();
      }, 0);
    }
  }

  initialize(options) {
    this.serpTrackingService = new SerpTrackingService();
    this.collectionView = options.collectionView;
    this.hotelMapView = options.hotelMapView;

    this.isPopupVisible = ref(false);
    this.partialPaymentPopup = false;

    this.render();
    this.initSubscribes();
  }

  hrefUrl(event) {
    const hotelOffer = this.model.get('hotelOffers').at(0);
    const identity = hotelOffer.get('id');
    const urlParams = toRouterHotelHydrator({
      tourCriteria: hotelOffer.get('tourCriteria'),
      similar: !!this.model.get('similar'),
      productType: 'hotelOffer',
      identity,
      minPrice: this.model.get('minPrice'),
      operatorId: hotelOffer.get('operator').id,
      sid: searchSessionService.getSearchId(),
      suuid: trackingService.getSearchUuid(),
    });
    const hotelUrl = this.model.get('url');
    const target = $('.oneColumn:visible').length ? '_self' : '_blank';
    const $target = $(event.currentTarget);

    if (typeof identity !== 'undefined') {
      if (event.which === 2) {
        gaAsync(() => {
          ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', { nonInteraction: 1 });
        });
      }
    } else if (event.which === 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
      gaAsync(() => {
        ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', { nonInteraction: 1 });
      });
    }
    if ($target.hasClass('distance')) {
      urlParams.toMap = true;
    }
    $(event.currentTarget).attr('href', `${hotelUrl}#?${$.param(urlParams)}`);
    $(event.currentTarget).attr('target', target);
    ls.set('isAbsent', false);
  }

  buildUrlParams() {
    const hotelOffer = this.model.get('hotelOffers').at(0);
    return toRouterHotelHydrator({
      tourCriteria: hotelOffer.get('tourCriteria'),
      productType: 'hotelOffer',
      identity: hotelOffer.get('id'),
      minPrice: this.model.get('minPrice'),
      operatorId: hotelOffer.get('operator').id,
      sid: searchSessionService.getSearchId(),
      suuid: trackingService.getSearchUuid(),
    });
  }
}
